// App Users translations for React Admin resource
export const appUsersResource = {
  name: '應用程式用戶',
  fields: {
    id: 'ID',
    authId: '認證 ID',
    email: '電子郵件',
    phone: '電話',
    firstName: '名字',
    lastName: '姓氏',
    name: '姓名',
    vehicleMake: '車輛品牌',
    vehicleModel: '車輛型號',
    carPlate: '車牌號碼',
    vehicle: '車輛',
    language: '語言',
    isActive: '啟用',
    isVerified: '已驗證',
    verified: '驗證狀態',
    wallet: '錢包',
    walletBalance: '錢包餘額',
    walletCurrency: '貨幣',
    lastSeenAt: '最後上線',
    lastUpdatedBy: '最後更新者',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
  noVehicle: '無車輛資訊',
  list: {
    title: '應用程式用戶',
    subtitle: '管理行動應用程式用戶',
    filters: {
      search: '搜尋電話、姓名或車牌',
      activeOnly: '僅顯示啟用用戶',
      verifiedOnly: '僅顯示已驗證用戶',
      language: '語言',
    },
    empty: {
      title: '尚無應用程式用戶',
      subtitle: '當用戶透過行動應用程式註冊後將會顯示在這裡',
    },
  },
  status: {
    active: '啟用',
    inactive: '停用',
    verified: '已驗證',
    unverified: '未驗證',
  },
  edit: {
    title: '編輯應用程式用戶',
    subtitle: '更新用戶資訊',
    basicInfo: '基本資訊',
    vehicleInfo: '車輛資訊',
    accountSettings: '帳號設定',
    walletInfo: '錢包資訊',
    notificationPreferences: '通知偏好設定',
    activityInfo: '活動資訊',
    activeAccount: '啟用帳號',
    emailHelperText: '更改將同步至認證和個人資料系統',
    phoneHelperText: '主要聯絡電話',
    accountWarning: '停用帳號將阻止用戶使用應用程式',
    walletReadOnly: '錢包餘額只能透過交易變更',
    backToList: '返回列表',
    phoneCannotEdit: '電話號碼無法更改。用戶必須通過應用程式驗證新的電話號碼。',
  },
  create: {
    title: '建立應用程式用戶',
    subtitle: '註冊新的行動應用程式用戶',
    infoMessage: '手動建立應用程式用戶。他們將能夠使用電話號碼登入。',
    basicInfo: '基本資訊',
    vehicleInfo: '車輛資訊',
    accountSettings: '帳號設定',
    notificationPreferences: '通知偏好設定',
    phoneHelperText: '這將是用戶的主要登入識別',
    phoneCannotEdit: '電話號碼無法更改。用戶必須通過應用程式驗證新的電話號碼。',
    vehicleMakeHelperText: '選擇車輛製造商',
    vehicleModelHelperText: '輸入車輛型號（例如：Model 3、e-tron）',
    carPlateHelperText: '車輛牌照號碼',
    walletInfo: '錢包資訊',
    walletHelperText: '將自動建立零餘額的錢包。用戶可以透過應用程式充值。',
    notificationPreferencesHelperText: '此用戶的預設通知設定',
    phoneValidation: {
      format: '請輸入有效的電話號碼',
    },
  },
  notifications: {
    chargingComplete: '充電完成',
    chargingInterrupted: '充電中斷',
    promotions: '優惠與促銷',
    systemUpdates: '系統更新',
    createSuccess: '應用程式用戶已成功建立',
    updateSuccess: '應用程式用戶已成功更新',
  },
  show: {
    subtitle: '檢視用戶詳情',
  },
  groupsPanel: {
    title: '群組',
    empty: '未加入任何群組',
    selectPlaceholder: '選擇群組...',
    noOptions: '找不到群組',
    noGroupsExist: '目前尚未建立任何用戶群組。',
    manageGroups: '管理用戶群組',
    save: '儲存群組',
    saved: '群組已儲存',
  },
};

export const appUsers = {
  'app-users': appUsersResource,
};